import _extends from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "mediaQuery"];
var __jsx = React.createElement;
import React, { forwardRef } from 'react';
import MediaQuery from './media-query';

/**
 * @type {React.FC<PropsWithChildren<{
 *  mediaQuery?: string;
 *  direction?: string;
 *  children?: Element;
 * }>>}
 */
var DesktopOnly = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$mediaQuery = _ref.mediaQuery,
    mediaQuery = _ref$mediaQuery === void 0 ? 'md' : _ref$mediaQuery,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return __jsx(MediaQuery, _extends({
    ref: ref,
    mediaQuery: mediaQuery
  }, otherProps, {
    direction: "up"
  }), children);
});
DesktopOnly.snapshot = false;
export default DesktopOnly;